module.exports = __webpack_public_path__ + "static/media/FBLOGO.64cfc332.png";